import { FC } from "react";
import { downloadsData } from "../configs/downloadsData";

export const Downloads: FC = () => {
  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">{downloadsData.title}</h2>
    </>
  );
}